import PATH from 'crono-fe-common/constants/path';

/**
 * Matches the `/connect/<provider>/callback` routes declared in
 * `pages/connect/routes`. They exchange a single-use OAuth code and navigate on
 * their own once it settles, so nothing else may redirect off one while it is
 * mounted: React Query drops the `mutate()` callbacks of an unmounted observer,
 * which loses the user refresh and the follow-up navigation even though the
 * exchange itself succeeds.
 */
const isOauthCallbackPathname = (pathname: string) =>
  pathname.startsWith(`${PATH.CONNECT}/`) && pathname.endsWith('/callback');

export default isOauthCallbackPathname;
